import { StructuredContent } from "./StructuredContent";

export default StructuredContent;
